import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Divider} from "primereact/divider";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";


const SourceConfiguration = props => {
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [cpuCount, setCpuCount] = useState(0);
    const [cpuCredit, setCpuCredit] = useState(0);
    const [gpuCount, setGpuCount] = useState(0);
    const [gpuCredit, setGpuCredit] = useState(0);
    const [ramSize, setRamSize] = useState(0);
    const [ramUnit, setRamUnit] = useState(null);
    const [ramCredit, setRamCredit] = useState(0);
    const [diskSize, setDiskSize] = useState(0);
    const [diskUnit, setDiskUnit] = useState(null);
    const [diskCredit, setDiskCredit] = useState(0);
    const [unitSize, setUnitSize] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);
    const [currencyUnit, setCurrencyUnit] = useState(0);

    const ram_unit_options = [
        {name: "KB", code: "KB"},
        {name: "MB", code: "MB"},
        {name: "GB", code: "GB"},
        {name: "TB", code: "TB"},
        {name: "PB", code: "PB"},
        {name: "EB", code: "EB"},
        {name: "ZB", code: "ZB"},
        {name: "YB", code: "YB"}
    ];

    const disk_unit_options = [
        {name: "KB", code: "KB"},
        {name: "MB", code: "MB"},
        {name: "GB", code: "GB"},
        {name: "TB", code: "TB"},
        {name: "PB", code: "PB"},
        {name: "EB", code: "EB"},
        {name: "ZB", code: "ZB"},
        {name: "YB", code: "YB"}
    ];

    useEffect(() => {
        getConfiguration();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getConfiguration = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-credit-configuration/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        ////console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            const conf_data = data.configuration;
                            const disk_unit = disk_unit_options.filter((item) => {
                                return item.code === conf_data["disk_unit"];
                            });
                            const ram_unit = ram_unit_options.filter((item) => {
                                return item.code === conf_data["ram_unit"];
                            });
                            setCpuCount(conf_data["cpu_count"]);
                            setCpuCredit(conf_data["cpu_credit"]);
                            setGpuCount(conf_data["gpu_count"]);
                            setGpuCredit(conf_data["gpu_credit"]);
                            setRamSize(conf_data["ram_size"]);
                            setRamUnit(ram_unit[0]);
                            setRamCredit(conf_data["ram_credit"]);
                            setDiskSize(conf_data["disk_size"]);
                            setDiskUnit(disk_unit[0]);
                            setDiskCredit(conf_data["disk_credit"]);
                            setUnitSize(conf_data["unit_size"]);
                            setUnitPrice(conf_data["unit_price"]);
                            setCurrencyUnit(conf_data["currency_unit"]);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const updateConfiguration = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (cpuCount < 1) {
                showError("CPU Sayısı En Az 1 Adet Olmalıdır");
                return;
            }
            if (cpuCredit === null) {
                showError("CPU Kredisi Belirtilmelidir");
                return;
            }
            if (gpuCount < 1) {
                showError("GPU Sayısı En Az 1 Adet Olmalıdır");
                return;
            }
            if (gpuCredit === null) {
                showError("GPU Kredisi Belirtilmelidir");
            }
            if (ramSize < 1) {
                showError("RAM Boyutu En Az 1 Birim Olmalıdır");
                return;
            }
            if (ramUnit === null) {
                showError("RAM Birimi Belirtilmelidir");
                return;
            }
            if (ramCredit === null) {
                showError("RAM Kredisi Belirtilmelidir.");
                return;
            }
            if (diskSize < 1) {
                showError("DİSK Boyutu En Az 1 Birim Olmalıdır");
                return;
            }
            if (diskUnit === null) {
                showError("DİSK Birimi Belirtilmelidir");
                return;
            }
            if (diskCredit === null) {
                showError("DİSK Kredisi Belirtilmelidir.");
                return;
            }
            if (unitSize < 1) {
                showError("Birim Boyutu En Az 1 Birim Olmalıdır");
                return;
            }
            if (unitPrice === null) {
                showError("Birim Fiyatı Belirtilmelidir");
                return;
            }
            if (currencyUnit === null || currencyUnit.length < 1) {
                showError("Fiyat Birimi Belirtilmelidir");
                return;
            }

            const data = {
                "cpu_count": cpuCount,
                "cpu_credit": cpuCredit,
                "gpu_count": gpuCount,
                "gpu_credit": gpuCredit,
                "ram_size": ramSize,
                "ram_unit": ramUnit.name,
                "ram_credit": ramCredit,
                "disk_size": diskSize,
                "disk_unit": diskUnit.name,
                "disk_credit": diskCredit,
                "unit_size": unitSize,
                "unit_price": unitPrice,
                "currency_unit": currencyUnit
            }
            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true);
            fetch("/api/cloud-credit-configuration/", {headers, method: "PUT", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const onRamUnitChange = (e) => {
        setRamUnit(e.value);
    }

    const onDiskUnitChange = (e) => {
        setDiskUnit(e.value);
    }

    return (
        <div className='p-fluid'>
            <Toast ref={toast}/>
            <Spinner loadingState={loadingState}/>
            <div className="card">
                <div className="p-grid">
                    <div className="p-col-12">
                        <h4>KREDİ KONFİGÜRASYONU</h4>
                    </div>
                    <Divider align="center"/>
                    <Divider align="left">
                        <div className="p-d-inline-flex p-ai-center">
                            <b>CPU</b>
                        </div>
                    </Divider>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="cpu_count"
                                     value={cpuCount}
                                     onValueChange={(e) => setCpuCount(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="cpu_count">CPU Sayısı</label>
                    </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="cpu_credit"
                                     value={cpuCredit}
                                     onValueChange={(e) => setCpuCredit(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="cpu_credit">CPU Kredisi</label>
                    </span>
                    </div>
                    <Divider align="left">
                        <div className="p-d-inline-flex p-ai-center">
                            <b>GPU</b>
                        </div>
                    </Divider>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="gpu_count"
                                     value={gpuCount}
                                     onValueChange={(e) => setGpuCount(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="gpu_count">GPU Sayısı</label>
                    </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="gpu_credit"
                                     value={gpuCredit}
                                     onValueChange={(e) => setGpuCredit(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="gpu_credit">GPU Kredisi</label>
                    </span>
                    </div>
                    <Divider align="left">
                        <div className="p-d-inline-flex p-ai-center">
                            <b>RAM</b>
                        </div>
                    </Divider>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="ram_size"
                                     value={ramSize}
                                     onValueChange={(e) => setRamSize(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="ram_size">RAM Boyutu</label>
                    </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="ram_credit"
                                     value={ramCredit}
                                     onValueChange={(e) => setRamCredit(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="ram_credit">RAM Kredisi</label>
                    </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <Dropdown inputId="ram_unit" value={ramUnit}
                                      options={ram_unit_options} onChange={onRamUnitChange}
                                      optionLabel="name"
                            />
                            <label htmlFor="ram_unit">RAM Birimi</label>
                        </span>
                    </div>
                    <Divider align="left">
                        <div className="p-d-inline-flex p-ai-center">
                            <b>DİSK</b>
                        </div>
                    </Divider>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                    <span className="p-float-label" style={{marginTop: '5px'}}>
                        <InputNumber inputId="disk_size"
                                     value={diskSize}
                                     onValueChange={(e) => setDiskSize(e.value)}
                                     showButtons
                                     buttonLayout="horizontal"
                                     step={1}
                                     incrementButtonClassName="p-button-secondary"
                                     decrementButtonClassName="p-button-secondary"
                                     incrementButtonIcon="pi pi-plus"
                                     decrementButtonIcon="pi pi-minus"
                        />
                        <label htmlFor="disk_size">DİSK Boyutu</label>
                    </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <InputNumber inputId="disk_credit"
                                         value={diskCredit}
                                         onValueChange={(e) => setDiskCredit(e.value)}
                                         showButtons
                                         buttonLayout="horizontal"
                                         step={1}
                                         incrementButtonClassName="p-button-secondary"
                                         decrementButtonClassName="p-button-secondary"
                                         incrementButtonIcon="pi pi-plus"
                                         decrementButtonIcon="pi pi-minus"
                            />
                            <label htmlFor="disk_credit">DİSK Kredisi</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <Dropdown inputId="disk_unit" value={diskUnit}
                                      options={disk_unit_options} onChange={onDiskUnitChange}
                                      optionLabel="name"
                            />
                            <label htmlFor="disk_unit">DİSK Birimi</label>
                        </span>
                    </div>
                    <Divider align="left">
                        <div className="p-d-inline-flex p-ai-center">
                            <b>FİYAT</b>
                        </div>
                    </Divider>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <InputNumber inputId="unit_size"
                                         value={unitSize}
                                         onValueChange={(e) => setUnitSize(e.value)}
                                         showButtons
                                         buttonLayout="horizontal"
                                         step={1}
                                         incrementButtonClassName="p-button-secondary"
                                         decrementButtonClassName="p-button-secondary"
                                         incrementButtonIcon="pi pi-plus"
                                         decrementButtonIcon="pi pi-minus"
                            />
                            <label htmlFor="unit_size">Birim Boyutu</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <InputNumber inputId="unit_price"
                                         value={unitPrice}
                                         onValueChange={(e) => setUnitPrice(e.value)}
                                         showButtons
                                         buttonLayout="horizontal"
                                         step={1}
                                         incrementButtonClassName="p-button-secondary"
                                         decrementButtonClassName="p-button-secondary"
                                         incrementButtonIcon="pi pi-plus"
                                         decrementButtonIcon="pi pi-minus"
                            />
                            <label htmlFor="unit_price">Birim Fiyatı</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                        <span className="p-float-label" style={{marginTop: '5px'}}>
                            <InputText id="currency_unit" value={currencyUnit}
                                       onChange={(e) => setCurrencyUnit(e.target.value)}
                            />
                            <label htmlFor="currency_unit">Fiyat Birimi</label>
                        </span>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4 p-mt-6">
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4 p-mt-6">
                        <Button label="Güncelle" icon="pi pi-save" onClick={(e) => updateConfiguration()}/>
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4 p-mt-6">
                    </div>
                </div>
            </div>


        </div>
    );


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(SourceConfiguration);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/SourceConfiguration.jsx